import { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../../firebase/config";
//import { User } from "../../../types/user";
import "../../../styles/DashboardStyles/Overlays/ResetPasswordModal.css";

interface User {
   id: string;        // Firestore document ID (userId)
  fullName: string;  // matches your Firestore field
  email: string;
  phone: string;
  role: string;
  accountStatus: string; // matches your Firestore field
  createdAt: any;
  updatedAt: any;
  userId: string;
}

interface Props {
  user: User;
  onClose: () => void;
}

export default function ResetPasswordModal({ user, onClose }: Props) {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleReset = async () => {
    setStatus("loading");
    try {
      await sendPasswordResetEmail(auth, user.email);
      setStatus("success");
    } catch (err: any) {
      setErrorMsg(err.message);
      setStatus("error");
    }
  };

  return (
    <>
      {/* Dark backdrop */}
      <div className="modal-backdrop" onClick={onClose} />

      {/* Modal box */}
      <div className="modal-box">

        {/* Header */}
        <div className="modal-header">
          <h2>Reset Password</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        {/* Body */}
        <div className="modal-body">

          {/* Idle — confirm screen */}
          {(status === "idle" || status === "loading") && (
            <>
              <div className="modal-icon">🔑</div>
              <p>A password reset email will be sent to:</p>
              <p className="modal-email">{user.email}</p>
              <p className="modal-hint">
                The user will receive a link to set a new password.
              </p>
            </>
          )}

          {/* Success */}
          {status === "success" && (
            <>
              <div className="modal-icon">✅</div>
              <p className="modal-success">Reset email sent successfully!</p>
              <p className="modal-hint">
                An email has been sent to <strong>{user.email}</strong>.
                The link expires after 1 hour.
              </p>
            </>
          )}

          {/* Error */}
          {status === "error" && (
            <>
              <div className="modal-icon">⚠️</div>
              <p className="modal-error">{errorMsg}</p>
            </>
          )}

        </div>

        {/* Footer buttons */}
        <div className="modal-footer">
          {status !== "success" && (
            <>
              <button
                className="btn-modal-cancel"
                onClick={onClose}
                disabled={status === "loading"}
              >
                Cancel
              </button>
              <button
                className="btn-modal-confirm"
                onClick={handleReset}
                disabled={status === "loading"}
              >
                {status === "loading" ? "Sending..." : "Send Reset Email"}
              </button>
            </>
          )}
          {status === "success" && (
            <button className="btn-modal-confirm" onClick={onClose}>
              Done
            </button>
          )}
        </div>

      </div>
    </>
  );
}